{
  "global.siteDescription": "Apresente-se de verdade em 30 segundos para que as pessoas conheçam você rapidamente.",
  "global.languageSwitch": "Mudar idioma",
  "global.languageCurrent": "Idioma atual: {locale}",
  "global.language.zh-CN": "中文",
  "global.language.zh-TW": "繁體中文",
  "global.language.en": "English",
  "global.language.ja": "日本語",
  "global.language.ko": "한국어",
  "global.language.es": "Español",
  "global.language.fr": "Français",
  "global.language.de": "Deutsch",
  "global.language.pt-BR": "Português (Brasil)",
  "global.language.ru": "Русский",
  "global.language.ar": "العربية",
  "common.close": "Fechar",
  "common.cancel": "Cancelar",
  "common.save": "Salvar",
  "common.delete": "Excluir",
  "common.edit": "Editar",
  "common.manage": "Gerenciar",
  "common.login": "Entrar",
  "common.logout": "Sair",
  "common.loggingOut": "Saindo",
  "common.logoutRetry": "Tentar sair novamente",
  "common.preview": "Visualização",
  "common.email": "Email",
  "common.inviteCode": "Código de convite",
  "common.loading": "Carregando",
  "editor.publish.processing": "Ainda em processamento",
  "common.localDraft": "Rascunho local",
  "common.publicBeta": "Beta pública",
  "common.serviceStatus": "Status do serviço",
  "common.optional": "Opcional",
  "common.page": "Página",
  "common.reason": "Motivo",
  "common.description": "Detalhes",
  "common.submit": "Enviar",
  "nav.login": "Entrar",
  "nav.draftFirst": "Iniciar um rascunho",
  "home.action.create": "Criar minha apresentação",
  "home.action.continue": "Continuar escrevendo",
  "home.action.manage": "Gerenciar apresentação",
  "home.action.agent": "Agent escreve por você",
  "home.meta.title": "30s.to — 30 segundos para conhecer você.",
  "home.meta.description": "Quando você segue por conta própria, se fazer conhecer importa ainda mais. 30 segundos para conhecer você. Quem você é, o que está fazendo, o que já fez e quais recursos pode oferecer. Ajude as pessoas a descobrir o que lhes interessa e se conectar com você.",
  "home.title": "30 segundos\npara conhecer você.",
  "home.freeNote": "Crie, publique e compartilhe. Grátis para sempre.",
  "home.kicker": "Quando você segue por conta própria, se fazer conhecer importa ainda mais.",
  "home.value.copy": "Quem você é, o que está fazendo, o que já fez e quais recursos pode oferecer. Ajude as pessoas a descobrir o que lhes interessa e se conectar com você.",
  "home.features.label": "Recursos",
  "home.features.time.tab": "Leia em 30 segundos",
  "home.why.copy": "Escreva só o mais importante. Quanto mais longa a apresentação, menos pessoas chegam ao fim. 30 segundos é a medida certa.",
  "home.principle.expression.title": "Expresse-se livremente",
  "home.principle.expression.copy": "Organize sua experiência, seus trabalhos, ideias e recursos do seu jeito. Compartilhe o que você quer que as pessoas saibam sobre você.",
  "home.principle.link.title": "Seu próprio link 30s.to",
  "home.principle.link.copy": "30s.to/@you é curto, fácil de lembrar e direto ao ponto: conhecer você em 30 segundos.",
  "home.principle.theme.title": "Temas variados para mostrar quem você é",
  "home.principle.theme.copy": "Minimalista, retrô ou ousado e vibrante. Escolha um tema que combine com você e mostre seu estilo logo no primeiro olhar.",
  "home.footer.tagline": "Diga menos para destacar o que importa.",
  "home.footer.navigation": "Navegação no rodapé",
  "home.demo.linkNotice": "Este é um link de demonstração. Crie sua introdução de 30 segundos para adicionar a sua própria.",
  "home.demo.profile.name": "Maya Chen",
  "home.demo.profile.identity": "Designer de produto independente transformando problemas complexos em produtos simples",
  "home.demo.profile.tag.product": "Design de produto",
  "home.demo.profile.tag.indie": "Produtos independentes",
  "home.demo.profile.tag.ai": "Ferramentas AI",
  "home.demo.profile.body": "## Agora\nEstou criando Briefly para designers independentes gastarem menos tempo movendo notas e mais entendendo pessoas. Antes de projetar, percorro a tarefa real com um usuário.\n\n## Minha trajetória\n2020–2023: design do editor e da integração de usuários em uma equipe de software colaborativo. Com engenheiros, dividi operações complexas em passos viáveis.\n\nDesde 2024 trabalho de forma independente com pesquisa e interação para equipes iniciais, além de criar meus produtos.\n\n## Projetos\n- [Relay](https://example.com/projects/relay): projetei este registro de decisões que reúne conclusões, motivos e responsáveis para contextualizar novos integrantes.\n- [Briefly](https://example.com/projects/briefly): em teste com um grupo pequeno, organiza entrevistas em temas rastreáveis e preserva falas originais para conferir interpretações.\n\n## O que posso oferecer\nTem feedback, mas não sabe o que mudar primeiro? Posso ajudar a definir o problema e criar um protótipo testável. Também compartilho roteiros de entrevistas e modelos de notas com equipes que começam a pesquisar.\n\n## Vamos conversar\nQuero conversar sobre primeiras entrevistas, escolhas e trabalho independente com quem cuida de pequenos produtos. Nos fins de semana exploro lojas do bairro: uma tabela de preços escrita à mão pode ensinar muito.",
  "home.demo.profile.link.website": "Trabalhar",
  "home.demo.profile.link.github": "GitHub",
  "home.demo.profile.link.calendar": "Agende um bate-papo",
  "handleStart.kicker": "URL pública",
  "handleStart.title": "Escolha sua URL 30s.to",
  "handleStart.copy": "Escolha primeiro uma URL fácil de lembrar e depois escreva sua apresentação de 30 segundos. Qualquer rascunho existente será mantido.",
  "handleStart.label": "Sua URL",
  "handleStart.help.empty": "4-24 letras minúsculas. Isso salva apenas um rascunho; a disponibilidade é confirmada na publicação.",
  "handleStart.help.ok": "O formato parece bom. A disponibilidade é verificada novamente na publicação.",
  "handleStart.submit": "Continuar escrevendo",
  "handleAvailability.checking": "Verificando esta URL…",
  "handleAvailability.available": "Disponível agora. Torna-se seu após uma publicação bem-sucedida.",
  "handleAvailability.owned": "Você já possui este endereço.",
  "handleAvailability.assigned": "Este endereço é atribuído a você e entra em vigor após a publicação.",
  "handleAvailability.failed": "Não foi possível verificar esta URL. Tente novamente.",
  "handleAvailability.rateLimited": "Muitas verificações. Tente novamente em {minutes} minutos.",
  "handleAvailability.retry": "Verifique novamente",
  "handleAvailability.suggestions": "Você também pode tentar",
  "handleAvailability.cooldown": "A URL pública ainda está no período de espera de 30 dias. Você poderá alterá-la após {date} ou restaurar a URL publicada atualmente.",
  "editor.shell.loading": "Carregando criar fluxo",
  "editor.shell.workspace": "Espaço de trabalho de introdução de 30 segundos",
  "editor.shell.canvas": "Superfície de escrita de introdução de 30 segundos",
  "editor.command.aria": "Barra de comando do editor",
  "editor.command.publish": "Publicar",
  "editor.command.publishUpdate": "Publicar alterações",
  "editor.command.publishSettings": "Publicar configurações",
  "editor.command.dashboard": "Dashboard",
  "editor.publish.success": "Publicado",
  "editor.publish.successAfterLogin": "Logado e publicado",
  "editor.publish.publishing": "Publicando…",
  "editor.publish.publishingDetail": "Estamos preparando sua página pública. Aguarde um momento.",
  "editor.publish.successDetail": "Sua página pública está atualizada e pronta para visualização.",
  "editor.publish.viewPublic": "Ver página pública",
  "editor.publish.cacheFailed": "mas a gravação do cache da página pública falhou.",
  "editor.command.login": "Conecte-se",
  "editor.handle.editTitle": "Editar endereço público",
  "editor.handle.claimAfterPublish": "Seu após publicação",
  "editor.handle.claimAfterPublishTitle": "Este endereço passa a ser seu após a publicação",
  "editor.status.signedIn": "Conectado",
  "editor.status.account": "Conta: {email}",
  "editor.status.localTitle": "Rascunho local",
  "editor.status.localCopy": "Este rascunho só é salvo neste dispositivo. Faça login para sincronizá-lo com a nuvem.",
  "editor.status.location": "Salvar localização",
  "editor.status.state": "Salvar status",
  "editor.status.emailLogin": "Login Email",
  "editor.autosave.savingShort": "Salvando",
  "editor.autosave.savedCloudShort": "Salvo na nuvem",
  "editor.autosave.savedLocalShort": "Salvo localmente",
  "editor.autosave.failedShort": "Falha ao salvar",
  "editor.autosave.signedInShort": "Conectado",
  "editor.autosave.cloud": "Nuvem",
  "editor.autosave.retry": "Precisa tentar novamente",
  "editor.autosave.device": "Este dispositivo",
  "editor.autosave.saving": "Salvamento automático...",
  "editor.autosave.savedLocal": "Salva automaticamente localmente",
  "editor.autosave.savedCloud": "Salva automaticamente na nuvem",
  "editor.autosave.authExpired": "A sessão expirou. Salvo localmente.",
  "editor.autosave.cloudFailed": "Falha ao salvar na nuvem. Salvo localmente.",
  "editor.autosave.cloudUnavailable": "A economia na nuvem ainda não está conectada. Salvo localmente.",
  "editor.autosave.failed": "Falha no salvamento automático. Copie seu conteúdo e tente novamente.",
  "editor.autosave.enabled": "O salvamento automático está ativado",
  "identity.namePlaceholder": "Seu nome",
  "identity.nameAria": "Nome ou apelido",
  "identity.identityPlaceholder": "Identidade de uma linha",
  "identity.identityAria": "Identidade de uma linha",
  "identity.tagsAria": "Etiquetas",
  "identity.addTag": "Adicionar etiqueta",
  "identity.removeTag": "Remover etiqueta {tag}",
  "body.emptyInstruction": "Escreva o que alguém mais precisa saber ao conhecer você.\nEscreva menos para que o mais importante seja visto. 30 segundos, na medida certa.",
  "body.templatesLabel": "Você também pode começar com um modelo",
  "body.templatesAria": "Modelos de identidade para o texto",
  "body.templateExampleLabel": "Perfil de exemplo",
  "body.viewTemplateExample": "Ver exemplo",
  "links.sectionAria": "Ligações",
  "links.documentTitle": "Ligações",
  "links.documentCopy": "Perfis sociais, reservas e detalhes de contato",
  "links.documentEmptyCopy": "Adicione um perfil social, página de reserva ou método de contato. Você pode alterá-los a qualquer momento.",
  "links.add": "Adicionar link",
  "links.addType": "Adicionar {label}",
  "links.edit": "Editar {label}",
  "links.addedAria": "Links adicionados",
  "links.closePanel": "Fechar editor de link",
  "links.editTitle": "Editar link",
  "links.addTitle": "Adicionar link",
  "links.chooseTypeAgain": "Escolha o tipo de link novamente",
  "links.calendarProvider": "Provedor de reservas",
  "links.displayName": "Nome de exibição",
  "links.duplicate": "{label} já foi adicionado.",
  "links.alreadyAdded": "{label} já adicionado",
  "links.bookingAlreadyAdded": "A reserva já foi adicionada",
  "links.remove": "Excluir",
  "links.category.social": "Social",
  "links.category.booking": "Reserva",
  "links.category.work": "Trabalhos / sites",
  "links.category.content": "Contente",
  "links.category.contact": "Contato",
  "links.category.other": "Outro",
  "links.type.x": "X",
  "links.type.github": "GitHub",
  "links.type.linkedin": "LinkedIn",
  "links.type.instagram": "Instagram",
  "links.type.youtube": "YouTube",
  "links.type.bilibili": "Bilibili",
  "links.type.xiaohongshu": "Xiaohongshu",
  "links.type.wechat": "Conta Oficial WeChat",
  "links.type.email": "Email",
  "links.type.calendar": "Reserva",
  "links.type.website": "Site",
  "links.type.newsletter": "Newsletter",
  "links.type.tiktok": "TikTok",
  "links.type.threads": "Threads",
  "links.type.mastodon": "Mastodon",
  "links.type.dribbble": "Dribbble",
  "links.type.jike": "Jike",
  "links.type.other": "Outro",
  "links.input.x": "Alça X",
  "links.input.github": "Alça GitHub",
  "links.input.linkedin": "LinkedIn URL",
  "links.input.instagram": "Alça Instagram",
  "links.input.youtube": "Alça YouTube",
  "links.input.bilibili": "Bilibili UID",
  "links.input.xiaohongshu": "Perfil Xiaohongshu URL",
  "links.input.wechat": "ID oficial da conta WeChat",
  "links.input.email": "Email",
  "links.input.calendar": "Caminho de reserva",
  "links.input.website": "Website URL",
  "links.input.newsletter": "Newsletter URL",
  "links.input.tiktok": "Alça TikTok",
  "links.input.threads": "Alça Threads",
  "links.input.mastodon": "Mastodon URL",
  "links.input.dribbble": "Alça Dribbble",
  "links.input.jike": "Perfil Jike URL",
  "links.input.other": "Ligação URL",
  "links.input.calendar.cal": "Caminho Cal.com",
  "links.input.calendar.calendly": "Caminho do calendário",
  "links.input.calendar.google": "Página de reserva Google Calendar",
  "links.input.calendar.microsoft": "Ligação Microsoft Bookings",
  "links.input.calendar.hubspot": "Ligação HubSpot Meetings",
  "links.input.calendar.savvycal": "Caminho SavvyCal",
  "links.input.calendar.tidycal": "Caminho do TidyCal",
  "links.input.calendar.zcal": "caminho zcal",
  "links.hint.handle": "Insira apenas o identificador, não um URL.",
  "links.hint.uid": "Insira apenas UID, não o perfil URL.",
  "links.hint.slug": "Insira apenas o caminho, não o URL completo.",
  "links.hint.email": "Isso cria um link mailto.",
  "links.hint.text": "Clicar na página pública copia esse valor.",
  "links.hint.url": "Insira um link https:// válido para esta plataforma.",
  "links.hint.calendarSlug": "Insira apenas o nome de usuário ou caminho de reserva, não o URL completo.",
  "links.hint.calendarUrl": "Entre na página de reserva completa URL para esta plataforma.",
  "rich.toolbarAria": "Barra de ferramentas de formatação de texto",
  "rich.heading": "Título da seção",
  "rich.paragraph": "Parágrafo",
  "rich.bold": "Audacioso",
  "rich.boldFallback": "texto em negrito",
  "rich.italic": "itálico",
  "rich.italicFallback": "texto em itálico",
  "rich.code": "Código embutido",
  "rich.comment": "Alternar comentário",
  "rich.ul": "Lista com marcadores",
  "rich.ol": "Lista numerada",
  "rich.link": "Link",
  "rich.linkPrompt": "Insira um link https:// ou mailto:",
  "rich.linkInvalid": "Os links suportam apenas https:// ou mailto:",
  "rich.linkFallback": "texto do link",
  "rich.aria": "Corpo de introdução de 30 segundos",
  "rich.more": "Mais formatação",
  "rich.quote": "Citação",
  "rich.strikethrough": "Tachado",
  "rich.strikethroughFallback": "texto tachado",
  "rich.codeBlock": "Bloco de código",
  "rich.codeBlockFallback": "código",
  "rich.taskList": "Lista de tarefas",
  "rich.table": "Tabela",
  "rich.tableSkeleton": "| Item | Descrição |\n| --- | --- |\n| Item um | Descrição um |\n| Item dois | Descrição dois |",
  "rich.indent": "Aumentar recuo",
  "rich.outdent": "Diminuir recuo",
  "rich.placeholder": "Escreva uma introdução Markdown que possa ser lida em 30 segundos...",
  "feedback.aria": "Escrevendo comentários",
  "feedback.timeTitle": "Tempo estimado de leitura",
  "feedback.preview": "Visualização",
  "feedback.previewMenu": "Abrir menu de visualização",
  "feedback.openAcceptancePreview": "Visualização de aceitação aberta",
  "feedback.acceptancePreviewCopy": "Ver o resultado da página pública neste dispositivo",
  "feedback.noIssues": "Sem problemas de bloqueio",
  "feedback.prePublish": "Verificações de pré-publicação",
  "feedback.ready": "Sem bloqueadores",
  "feedback.itemCount": "Itens {count}",
  "feedback.valid": "O conteúdo passa nas verificações de publicação.",
  "issue.action.displayName": "Adicionar nome",
  "issue.action.oneLineIdentity": "Adicionar identidade",
  "issue.action.tags": "Adicionar tags",
  "issue.action.body": "Voltar ao texto",
  "issue.action.handle": "Escolha o endereço",
  "issue.action.links": "Gerenciar links",
  "issue.action.view": "Visualizar",
  "issue.short.displayName": "Nome ausente",
  "issue.short.oneLineIdentity": "Identidade ausente",
  "issue.short.tags": "Tags ausentes",
  "issue.short.handle": "Endereço ausente",
  "issue.short.readingTime": "Mais de 60s",
  "issue.short.readingTimeLong": "Mais de 30s",
  "issue.short.readingTimeShort": "Muito pouco conteúdo",
  "issue.short.bodyPlaceholder": "Conteúdo de exemplo no texto",
  "issue.short.bodyFormat": "Formato do texto",
  "issue.short.links": "Problema de link",
  "issue.short.linksEmpty": "Links podem ser adicionados",
  "issue.short.pending": "Precisa de trabalho",
  "issue.summary.more": "Itens {count} para corrigir",
  "publish.title.create": "Confirmar publicação",
  "publish.title.update": "Confirmar alterações",
  "publish.action.create": "Publicar em 30s.to",
  "publish.action.update": "Publicar alterações",
  "publish.closeAria": "Fechar confirmação de publicação",
  "publish.address": "Endereço público",
  "publish.unpublishedChanges": "Alterações não publicadas",
  "publish.handleChanged": "Seu endereço mudará de @{oldHandle} para @{newHandle}. O anterior redirecionará por 30 dias. Após 180 dias da mudança, ele poderá ser atribuído a outra pessoa, e links antigos poderão mostrar o perfil dela.",
  "publish.readingTime": "Tempo de leitura",
  "publish.status": "Status",
  "publish.ready": "Preparar",
  "publish.todo": "Itens {count} para melhorar",
  "publish.visibility": "Forma de publicação",
  "publish.visibility.indexed": "Permitir indexação em buscadores",
  "publish.visibility.unlisted": "Acesso por link",
  "publish.visibility.indexedNote": "Qualquer pessoa pode ver, e a página pode aparecer nos resultados de busca.",
  "publish.visibility.unlistedNote": "Qualquer pessoa com o link pode ver; não enviaremos a página aos buscadores.",
  "publish.visibility.publicNote": "As duas opções são públicas e o link pode ser encaminhado. Mantenha como rascunho se apenas você deve ver.",
  "publish.publicContent": "Ao publicar, seu nome, identidade, tags, texto e links ficam públicos. Comentários do autor não aparecem, mas não devem conter segredos.",
  "publish.noop": "A página pública já está atualizada. Altere o conteúdo ou a visibilidade antes de publicar novamente.",
  "publish.valid": "O conteúdo passa nas verificações de publicação.",
  "handleEdit.title": "Editar endereço público",
  "handleEdit.label": "Endereço 30s.to",
  "handleEdit.help.changed": "Salvar altera apenas o rascunho. Após a publicação, o endereço anterior redirecionará por 30 dias e poderá ser reatribuído após 180 dias.",
  "handleEdit.help.saved": "Salvo no rascunho. A disponibilidade é verificada novamente na publicação.",
  "handleEdit.note": "O endereço público atual ainda é 30s.to/@{handle}. O novo endereço entra em vigor após a publicação.",
  "handleEdit.save": "Salvar no rascunho",
  "conflict.title": "Escolha a versão de rascunho",
  "conflict.copy": "Este dispositivo e a nuvem possuem conteúdo não publicado. Sua escolha se torna a próxima versão a ser editada.",
  "conflict.useLocal": "Usar rascunho local",
  "conflict.useLocalCopy": "Mantenha o conteúdo atual da página e sincronize-o com a nuvem.",
  "conflict.useCloud": "Usar rascunho na nuvem",
  "conflict.untitled": "Sem título",
  "conflict.cloudVersion": "Versão salva na nuvem",
  "conflict.modifiedAt": "Última edição · {time}",
  "conflict.time.justNow": "agora mesmo",
  "conflict.time.minutesAgo": "há {count} min",
  "conflict.time.hoursAgo": "há {count} h",
  "conflict.time.daysAgo": "há {count} dias",
  "authModal.title": "Faça login em 30s.to",
  "authModal.copy": "Após o login, os rascunhos são sincronizados com a nuvem e a publicação é mais confiável.",
  "login.page.eyebrow": "Conta",
  "login.page.title": "Faça login em 30s.to",
  "login.page.copy": "Sincronize rascunhos, publique páginas públicas e gerencie convites.",
  "login.invalidEmail": "Insira um e-mail válido.",
  "login.sendFailed": "Não foi possível enviar o código.",
  "login.devCodeReady": "Código de desenvolvimento local gerado.",
  "login.codeSent": "Código enviado. Verifique seu e-mail.",
  "login.networkSendFailed": "Não foi possível enviar o código. Verifique sua conexão.",
  "login.invalidCode": "Digite o código de 6 dígitos.",
  "login.codeInvalid": "O código está errado ou expirou.",
  "login.failed": "Falha no login. Tente novamente mais tarde.",
  "login.sendBusy": "Enviando...",
  "login.resendCode": "Reenviar código",
  "login.sendCode": "Enviar código",
  "login.localCode": "Código de desenvolvimento local: {code}",
  "login.code": "Código",
  "login.codePlaceholder": "6 dígitos",
  "login.inviteHelp": "O Beta Público requer um código de convite. A verificação ativa sua conta.",
  "login.verifyBusy": "Verificando...",
  "login.verifyInvite": "Verifique o convite e faça login",
  "login.verify": "Faça login e continue",
  "login.footnote": "Login sem senha. Novos usuários são ativados com um convite após verificação por e-mail.",
  "login.google": "Continuar com o Google",
  "login.github": "Continuar com GitHub",
  "login.emailDivider": "ou use e-mail",
  "login.oauthFailed": "O login social não foi concluído. Tente novamente ou use o login por e-mail.",
  "login.linkTitle": "Verifique o e-mail da conta",
  "login.linkPageCopy": "Uma conta 30s.to já usa este e-mail. Nós o vinculamos somente após verificação; as contas nunca são mescladas automaticamente.",
  "login.linkCopy": "Enviaremos um código para {email}. O e-mail não pode ser alterado aqui.",
  "login.linkVerify": "Verifique e vincule",
  "login.linkRequired": "Uma conta existente foi encontrada. Verifique seu e-mail para continuar.",
  "login.activateTitle": "Ativar 30s.to",
  "login.activatePageCopy": "Sua identidade social foi verificada. Nenhuma conta permanente será criada até que o convite seja bem-sucedido.",
  "login.activateCopy": "O Beta Público requer um convite. Ele é resgatado somente quando a criação da conta for bem-sucedida.",
  "login.activationOpenCopy": "O cadastro está aberto. Continue para ativar sua conta.",
  "login.activationClosedCopy": "A ativação de novas contas está pausada. Contas existentes ainda podem entrar.",
  "login.activate": "Ativar e continuar",
  "login.inviteRequired": "Email verificado. Use um convite para ativar.",
  "login.useEmailInstead": "Use o login por e-mail",
  "preview.emptyEyebrow": "Visualização",
  "preview.emptyTitle": "Nenhuma introdução disponível para visualização.",
  "preview.backToEdit": "Voltar para editar",
  "preview.edit": "Editar",
  "preview.localNoteAria": "Nota de visualização local",
  "preview.localNote": "Aceitação local",
  "preview.localTitle": "Visualização do rascunho neste dispositivo",
  "preview.themePicker": "Alternador de tema",
  "preview.themeGroup": "Escolha o tema",
  "preview.themeFree": "Base",
  "preview.themePro": "Pró",
  "preview.mobileAria": "Pré-visualização da página pública para dispositivos móveis",
  "preview.close": "Fechar visualização",
  "preview.editorTitle": "Visualização",
  "preview.publicTitle": "Pré-visualização da página pública",
  "preview.shareCardButton": "Ver cartão temático",
  "preview.shareCardDialogTitle": "Visualização do cartão temático",
  "preview.shareCardTitle": "Cartão temático {theme}",
  "preview.shareCardLogin": "Faça login para renderizar a visualização real",
  "preview.shareCardLoading": "Renderizando o cartão temático…",
  "preview.shareCardError": "A visualização do cartão está temporariamente indisponível",
  "preview.shareCardNote": "O cartão temático usa a mesma linguagem visual da página pública. Cartões universais estão disponíveis em Dashboard.",
  "public.copySuccess": "Copiado {label}",
  "public.copyFailed": "Falha na cópia. Copie manualmente.",
  "public.createMine": "Criar minha introdução",
  "public.report": "Denunciar esta página",
  "public.ownerAria": "Entrada de gerenciamento pessoal",
  "public.owner.manage": "Gerenciar",
  "public.owner.edit": "Editar",
  "public.status.unavailable": "Indisponível",
  "public.status.notFound": "404",
  "public.status.moderated": "Esta introdução de 30 segundos não está disponível.",
  "public.status.frozen": "Este endereço público não está disponível.",
  "public.status.unpublished": "Esta introdução de 30 segundos ainda não foi publicada.",
  "theme.footer": "Feito com 30s.to",
  "theme.fallback.name": "Seu nome",
  "theme.fallback.nameUpper": "SEU NOME",
  "theme.fallback.nameNoir": "Nome",
  "theme.fallback.nameIndex": "John Doe",
  "theme.fallback.identity": "O que você faz?",
  "theme.fallback.identityUpper": "SUA IDENTIDADE E MISSÃO DE UMA LINHA",
  "theme.fallback.identityIndex": "Desconhecido",
  "theme.fallback.identityNoir": "Identidade",
  "theme.fallback.terminalName": "convidado",
  "theme.fallback.terminalIntro": "Nenhuma breve introdução ainda",
  "theme.terminal.commandLabel": "Comando terminal",
  "theme.terminal.commandSubmit": "Executar comando",
  "theme.terminal.outputLabel": "Saída de terminal interativo",
  "theme.connect": "CONECTAR",
  "theme.markdown.tableRegion": "Tabela do conteúdo, com rolagem horizontal",
  "theme.markdown.task": "Tarefa",
  "theme.tags": "ETIQUETAS",
  "theme.verified": "VERIFICADO",
  "theme.name": "NOME",
  "theme.identityLabel": "IDENTIDADE",
  "theme.keywords": "PALAVRAS-CHAVE",
  "theme.scroll": "Rolar",
  "theme.pixel.previous": "Tela anterior",
  "theme.pixel.next": "Próxima tela",
  "theme.pixel.screen": "Tela {current} de {total}",
  "theme.arcade.stage": "Estágio {current} / {total}",
  "theme.noise.reseed": "Ruído de nova propagação",
  "theme.readingTime": "{seconds} s de leitura",
  "theme.readingUnit": "s de leitura",
  "theme.letter.greeting": "Olá,",
  "theme.letter.signoff": "Abraços,",
  "theme.letter.postscript": "Você pode me encontrar aqui",
  "theme.letter.written": "Escrito em {date}",
  "dashboard.loginTitle": "Faça login para gerenciar sua introdução.",
  "dashboard.loginAction": "Faça login e gerencie",
  "dashboard.bannedTitle": "Esta conta não está disponível no momento.",
  "dashboard.bannedCopy": "Se você acredita que isso é um erro, entre em contato conosco por meio do relatório e recurso.",
  "connections.kicker": "Conta",
  "connections.title": "Métodos de login",
  "connections.settingsKicker": "Configurações",
  "connections.settingsTitle": "Conta e conexões",
  "connections.settingsCopy": "Gerencie identidades de login e o acesso de Agents de terceiros.",
  "connections.backToDashboard": "Voltar ao painel",
  "connections.emailCode": "Código de verificação por e-mail",
  "connections.alwaysAvailable": "Sempre disponível",
  "connections.connect": "Conectar",
  "connections.disconnect": "Remover link 30s.to",
  "connections.notConnected": "Não conectado",
  "connections.noEmail": "Nenhum e-mail fornecido",
  "connections.emailVerified": "Email verificado",
  "connections.connected": "Conectado",
  "connections.unavailable": "Não ativado",
  "connections.confirm": "Remover o link {provider} de 30s.to? O login Email permanece disponível.",
  "connections.removed": "O link de identidade foi removido de 30s.to.",
  "connections.failed": "Não foi possível atualizar os métodos de login. Tente novamente mais tarde.",
  "connections.help": "Isso remove apenas o mapeamento de identidade 30s.to; não revoga o acesso do provedor. Gerenciar o acesso do provedor:",
  "agentConnections.kicker": "Agent",
  "agentConnections.title": "Conexões de Agent",
  "agentConnections.copy": "Instale uma única Skill para seus Agents habituais coletarem informações, redigirem e atualizarem com segurança seu rascunho do 30s.to.",
  "agentConnections.addTitle": "Conectar um novo Agent",
  "agentConnections.addCopy": "Ver URL de conexão e etapas de configuração",
  "agentConnections.examplesDisclosure": "Ver exemplos de uso",
  "settings.title": "Configurações",
  "settings.copy": "Gerencie sua conta, segurança, conexões externas e o plano do 30s.to.",
  "settings.navAria": "Categorias de configuração",
  "settings.account.title": "Conta",
  "settings.account.copy": "Sua identidade no 30s.to e o acesso ao seu perfil.",
  "settings.account.email": "E-mail da conta",
  "settings.account.profile": "Perfil",
  "settings.account.plan": "Plano atual",
  "settings.account.manageProfile": "Gerenciar perfil",
  "settings.login.copy": "Gerencie as identidades usadas para entrar no 30s.to.",
  "settings.billing.copy": "Confira seu plano atual, a renovação e o acesso ao faturamento.",
  "settings.invites.copy": "Gerencie sua cota de convites do Public Beta e os códigos recentes.",
  "agentConnections.endpoint": "URL de conexão",
  "agentConnections.copyAction": "Copiar",
  "agentConnections.copied": "Copiado",
  "agentConnections.copyFailed": "Não foi possível copiar. Copie a URL manualmente.",
  "agentConnections.endpointCopied": "URL de conexão copiada.",
  "agentConnections.stepsAria": "Etapas para conectar um Agent",
  "agentConnections.step1": "Adicione um serviço remoto nas configurações de MCP ou conectores do seu Agent.",
  "agentConnections.step2": "Cole a URL de conexão, entre no 30s.to e autorize o acesso.",
  "agentConnections.step3": "Diga ao Agent o que deve mudar e volte ao 30s.to para revisar o rascunho.",
  "agentConnections.examplesTitle": "Experimente pedir",
  "agentConnections.exampleFirst": "Leia meu perfil do 30s.to e as regras de formatação e me ajude a concluir minha primeira apresentação.",
  "agentConnections.exampleSection": "Mantenha meu tom e reescreva apenas a seção ‘Agora’.",
  "agentConnections.exampleShorten": "Encurte toda a apresentação para menos de 30 segundos. Não publique.",
  "agentConnections.copyExample": "Copiar exemplo {number}",
  "agentConnections.promptCopied": "Exemplo de instrução copiado.",
  "agentConnections.boundary": "Os Agents só podem ler e atualizar rascunhos. Eles não podem publicar nem interromper a publicação por você.",
  "agentConnections.authorizedTitle": "Conexões autorizadas",
  "agentConnections.empty": "Nenhum Agent foi autorizado ainda.",
  "agentConnections.disabled": "As conexões de Agent ainda não estão ativadas.",
  "agentConnections.scopeRead": "Ler rascunho",
  "agentConnections.scopeWrite": "Atualizar rascunho",
  "agentConnections.connectedAt": "Conectado em {date}",
  "agentConnections.selfReported": "O nome do cliente é informado pelo próprio cliente",
  "agentConnections.revoke": "Revogar",
  "agentConnections.confirm": "Revogar a conexão com {client}? Esse cliente não poderá mais acessar seu rascunho do 30s.to.",
  "agentConnections.confirmSkill": "Revogar a conexão da Skill do 30s.to? Os Agents locais que usam esta Skill serão desconectados do 30s.to.",
  "agentConnections.revoked": "Conexão de Agent revogada.",
  "agentConnections.failed": "Não foi possível atualizar as conexões de Agent. Tente novamente mais tarde.",
  "agentConnections.manualTitle": "Conectar Remote MCP manualmente",
  "agentConnections.manualCopy": "Avançado: autorize separadamente um cliente compatível com Remote MCP",
  "skill.meta.title": "30s.to Skill — Deixe seu Agent escrever sua apresentação",
  "skill.meta.description": "Envie seu site, projetos ou portfólio. O Agent pesquisa seu trabalho e entrevista você para escrever sua apresentação de 30 segundos.",
  "skill.kicker": "30s.to Skill",
  "skill.title": "Sua apresentação,\ncom seu agente.",
  "skill.copy": "Envie alguns links. Seu agente conhece você e ajuda a escrever uma apresentação para ler em 30 segundos.",
  "skill.processTitle": "Como o Agent ajuda você a escrever",
  "skill.process.clues.title": "Envie links",
  "skill.process.clues.copy": "Seu perfil público, site do projeto ou portfólio.",
  "skill.process.research.title": "Pesquisa a fundo, depois entrevista",
  "skill.process.research.copy": "Ele pesquisa a fundo seu site, projetos e trabalhos, organiza os pontos principais e depois entrevista você para completar o que falta.",
  "skill.process.profile.title": "O Agent escreve sua apresentação",
  "skill.process.profile.copy": "Vocês ajustam o conteúdo e o tom até a apresentação ter a sua cara.",
  "skill.installTitle": "Instale no seu Agent",
  "skill.installCopy": "Copie a instrução, cole no agente que você costuma usar e envie.",
  "skill.promptLabel": "Instrução de instalação",
  "skill.copyPrompt": "Copiar instrução de instalação",
  "skill.promptCopied": "Instrução de instalação copiada. Agora abra o Agent que você usa, cole a instrução e envie.",
  "skill.copyFailed": "Não foi possível copiar. Selecione e copie a instrução de instalação abaixo.",
  "skill.startTitle": "Como começar",
  "skill.start.install": "Instale a Skill do 30s.to",
  "skill.start.chat": "Comece a conversar",
  "skill.start.chatCopy": "Depois de instalar, abra uma nova conversa e diga:",
  "skill.start.prompt": "Me ajude a escrever minha apresentação com o 30s.to.",
  "dashboard.kicker": "Minha introdução",
  "dashboard.defaultTitle": "Minha introdução de 30 segundos",
  "dashboard.primaryEdit": "Continuar editando",
  "dashboard.primaryCreate": "Comece a criar",
  "dashboard.unpublished": "Não publicado",
  "dashboard.unselected": "Não selecionado",
  "dashboard.confirmDiscard": "Descartar alterações não publicadas e restaurar a versão pública atual?",
  "dashboard.discardFailed": "Não foi possível descartar as alterações.",
  "dashboard.discardConflict": "Este rascunho foi alterado em outro lugar. Atualize a página e revise-o antes de tentar novamente.",
  "dashboard.discardNetworkFailed": "Não foi possível descartar as alterações. Tente novamente mais tarde.",
  "dashboard.discardDone": "Restaurado para a versão pública atual.",
  "dashboard.statusAria": "Estado atual",
  "dashboard.versionAria": "Relacionamento de versão",
  "dashboard.publicPage": "Página pública",
  "dashboard.indexingAllowed": "Indexação permitida",
  "dashboard.indexingBlocked": "Acesso por link",
  "dashboard.publicVersion": "Versão publicada",
  "dashboard.invisible": "Ainda não está visível para outras pessoas",
  "dashboard.draft": "Rascunho",
  "dashboard.currentDraft": "Versão editável atual",
  "dashboard.draftSynced": "Sincronizado com a página pública",
  "dashboard.editableVersionEmpty": "Versão editável · Não criada",
  "dashboard.editableVersionDirty": "Versão editável · Alterações não publicadas",
  "dashboard.editableVersionSynced": "Versão editável · Corresponde à página pública",
  "dashboard.editableVersionUnpublished": "Versão editável · Não publicada",
  "dashboard.betaActive": "Ativo",
  "dashboard.betaInactive": "Inativo",
  "dashboard.adminCanPublish": "A conta de administrador pode publicar",
  "dashboard.betaAccessNote": "Acesso público à publicação Beta",
  "dashboard.visibility": "Visibilidade",
  "dashboard.chooseOnPublish": "Escolha durante a confirmação de publicação",
  "dashboard.snapshot": "Instantâneo",
  "dashboard.snapshotAfterPublish": "O instantâneo da página pública é gerado após a publicação",
  "dashboard.publishDetailsAria": "Detalhes de publicação",
  "dashboard.actionsAria": "Ações de gestão",
  "dashboard.nextAction": "Próxima etapa",
  "dashboard.openPublicPage": "Abrir página pública",
  "dashboard.changeVisibility": "Alterar forma de publicação",
  "dashboard.unpublish": "Parar de publicar",
  "dashboard.unpublishTitle": "Parar de publicar?",
  "dashboard.unpublishDescription": "A página pública ficará indisponível imediatamente. O rascunho e o endereço público serão mantidos para você publicar novamente.",
  "dashboard.unpublishWarning": "Cópias já salvas por buscadores ou outras pessoas podem não desaparecer imediatamente.",
  "dashboard.unpublishConfirm": "Parar de publicar",
  "dashboard.unpublishBusy": "Parando...",
  "dashboard.unpublishSuccess": "A página pública não está mais disponível. O rascunho e o endereço público foram mantidos.",
  "dashboard.unpublishFailed": "Não foi possível parar de publicar. Tente novamente mais tarde.",
  "dashboard.discardBusy": "Restaurando...",
  "dashboard.discard": "Descartar alterações",
  "dashboard.metricsAria": "Dados leves",
  "dashboard.views": "Visualizações",
  "dashboard.clicks": "Cliques",
  "dashboard.readingTime": "Tempo de leitura",
  "dashboard.theme": "Tema",
  "dashboard.noTheme": "Não selecionado",
  "dashboard.visibility.indexed": "Permitir indexação em buscadores",
  "dashboard.visibility.unlisted": "Acesso por link",
  "dashboard.visibility.indexedNote": "Pode aparecer nos resultados de busca",
  "dashboard.visibility.unlistedNote": "Continua visível para qualquer pessoa com o link direto",
  "dashboard.snapshot.ready": "Cache pronto",
  "dashboard.snapshot.failed": "Reserva D1",
  "dashboard.snapshot.none": "Não gerado",
  "dashboard.snapshot.readyNote": "Instantâneo público gravado em KV",
  "dashboard.snapshot.failedNote": "A página pública ainda funciona por meio do substituto D1",
  "dashboard.snapshot.noneNote": "Nenhum instantâneo está disponível para a versão publicada atualmente",
  "invite.title": "Convide amigos para o Beta Público",
  "invite.remaining": "Convites {remaining} / {quota} restantes este mês.",
  "invite.generateFailed": "Não foi possível gerar o convite.",
  "invite.generated": "{count} códigos de convite foram gerados. Eles só aparecem desta vez.",
  "invite.quotaUsed": "Cota de convite mensal usada.",
  "invite.generating": "Gerando...",
  "invite.generate": "Gerar os {count} restantes",
  "invite.batchTitle": "{count} códigos gerados agora",
  "invite.copyAll": "Copiar todos os códigos",
  "invite.copiedAll": "Todos os códigos copiados",
  "invite.copyMessage": "Copiar mensagem",
  "invite.messageCopied": "Mensagem copiada",
  "invite.share": "Compartilhar",
  "invite.shared": "A tela de compartilhamento foi aberta.",
  "invite.shareFallback": "O compartilhamento direto não está disponível; a mensagem foi copiada.",
  "invite.shareFailed": "Não foi possível compartilhar. Copie a mensagem.",
  "invite.shareMessage": "Estou usando o 30s.to para criar uma apresentação pessoal de 30 segundos. Experimente também.\n\nCódigos de convite:\n{codes}\n\nAbra {url} para começar.",
  "invite.recentAria": "Status de uso dos convites",
  "invite.statusTitle": "Status de uso",
  "invite.statusSummary": "{active} disponíveis · {redeemed} usados · {expired} expirados · {revoked} revogados",
  "invite.status.revoked": "Revogado",
  "invite.status.redeemed": "Usado",
  "invite.status.expired": "Expirado",
  "invite.status.active": "Disponível",
  "invite.copy": "Cópia",
  "invite.copied": "Copiado",
  "invite.showOnce": "Mostrado apenas uma vez",
  "invite.expiryUnknown": "Expiração desconhecida",
  "invite.expiresAt": "Expira em {date}",
  "management.handlePending.title": "Alteração de endereço pendente",
  "management.handlePending.description": "O endereço público atual ainda é {publishedAddress}. A publicação ativa {draftAddress}.",
  "management.handlePending.next": "Publique as alterações antes que {draftAddress} se torne o endereço público.",
  "management.dirty.title": "Alterações não publicadas",
  "management.dirty.description": "Seu rascunho não foi publicado na página pública.",
  "management.dirty.next": "Publique alterações para sincronizar a página pública com este rascunho.",
  "management.published.title": "Publicado",
  "management.published.description": "A página pública está atualizada.",
  "management.published.next": "A página pública está sincronizada. Continue editando quando quiser ajustá-lo.",
  "management.unpublished.title": "Não publicado",
  "management.unpublished.description": "Esta introdução ainda está salva apenas como rascunho.",
  "management.unpublished.next": "Publique-o antes que outros possam visitar o endereço público.",
  "management.empty.title": "Sem introdução ainda",
  "management.empty.description": "Escolha um endereço e escreva uma introdução de 30 segundos.",
  "management.empty.next": "Crie um rascunho primeiro. As verificações de pré-publicação permanecem no editor.",
  "management.publish.create": "Publicar introdução",
  "management.publish.update": "Publicar alterações",
  "abuse.kicker": "Confiança e Segurança",
  "abuse.title": "Página do relatório",
  "abuse.copy": "Os relatórios são usados ​​apenas para revisão de segurança. Sua identidade não é pública.",
  "abuse.missingHandle": "Destino do relatório ausente.",
  "abuse.done": "Relatório recebido. Iremos revisá-lo em breve.",
  "abuse.failed": "O envio falhou. Tente novamente mais tarde.",
  "abuse.reason.spam": "Spam",
  "abuse.reason.impersonation": "Representação",
  "abuse.reason.abuse": "Assédio ou ódio",
  "abuse.reason.illegal": "Conteúdo ilegal",
  "abuse.reason.other": "Outro problema",
  "abuse.submitBusy": "Enviando...",
  "abuse.submit": "Enviar relatório",
  "terms.title": "Termos de Serviço",
  "privacy.title": "Aviso de privacidade",
  "validation.handle.required": "Insira um identificador.",
  "validation.handle.invalid": "O identificador deve ter de 4 a 24 letras minúsculas em inglês.",
  "validation.handle.reserved": "Este endereço público não está disponível. Tente outro.",
  "validation.handle.unavailable": "Este endereço público não está disponível. Tente outro.",
  "validation.handle.frozen": "Este endereço público não está disponível. Tente outro.",
  "validation.handle.protected": "Este endereço público não está disponível. Tente outro.",
  "validation.handle.checkFailed": "Não foi possível confirmar este endereço.",
  "validation.handle.changeLimit": "Você pode alterar seu endereço público apenas uma vez a cada 30 dias.",
  "validation.displayName.required": "Nome ou apelido é obrigatório.",
  "validation.identity.required": "A identidade de uma linha é necessária.",
  "validation.tags.range": "Adicione de 1 a 5 tags.",
  "validation.links.limit": "Você pode adicionar até {limit} links independentes.",
  "validation.links.empty": "Ainda não há links. Você pode adicionar um perfil social, página de reserva ou método de contato.",
  "validation.input.tooLong": "O texto pode ter no máximo {limit} caracteres.",
  "validation.body.placeholder": "O texto ainda contém {detail}. Substitua por conteúdo real ou exclua.",
  "validation.body.oldTemplate": "o modelo de texto anterior",
  "validation.body.readingTime": "A leitura estimada é de {seconds} segundos. Reduza para no máximo {maximum} segundos.",
  "validation.body.readingTimeLong": "A leitura estimada é de {seconds} segundos, acima dos {recommended} segundos recomendados, mas ainda é possível publicar.",
  "validation.body.readingTimeShort": "A leitura estimada é de {seconds} segundos. Adicione conteúdo até chegar a pelo menos {minimum} segundos.",
  "validation.markdown.h1": "# títulos de nível de página não são suportados",
  "validation.markdown.deepHeading": "### e títulos mais profundos não são suportados",
  "validation.markdown.image": "A sintaxe da imagem não é suportada",
  "validation.markdown.codeBlock": "Blocos de código não são suportados",
  "validation.markdown.taskList": "Listas de tarefas não são suportadas",
  "validation.markdown.table": "Tabelas não são suportadas",
  "validation.markdown.footnote": "Notas de rodapé não são suportadas",
  "validation.markdown.html": "HTML e incorporações não são suportadas",
  "validation.markdown.commentUnclosed": "O comentário não tem o marcador de fechamento -->",
  "validation.markdown.commentStrayClose": "O comentário não tem o marcador de abertura <!--",
  "validation.markdown.commentNested": "Comentários <!-- --> aninhados não são suportados",
  "validation.markdown.nestedHeading": "Títulos de seção devem ficar na raiz do documento",
  "validation.markdown.setextHeading": "Títulos Setext não são compatíveis",
  "validation.markdown.headingInline": "Títulos de seção só podem conter texto simples",
  "validation.markdown.frontmatter": "Frontmatter não é compatível",
  "validation.markdown.indentedCode": "Blocos de código indentados não são compatíveis; use um bloco cercado",
  "validation.markdown.codeFenceUnclosed": "Falta o marcador de fechamento do bloco de código",
  "validation.markdown.codeLanguage": "A linguagem aceita 1–32 letras, números, _, + ou -",
  "validation.markdown.listDepth": "Listas aceitam até três níveis",
  "validation.markdown.tableSize": "Tabelas aceitam até 6 colunas e 20 linhas",
  "validation.markdown.linkProtocol": "Links do corpo só aceitam HTTPS e e-mail",
  "validation.link.unsupportedType": "Este tipo de link ainda não é compatível. Escolha um link de site, plataforma ou agendamento.",
  "validation.link.labelRequired": "O nome do link não pode ficar vazio.",
  "validation.link.providerRequired": "Escolha uma plataforma de reservas.",
  "validation.link.valueRequired": "{label} não pode estar vazio.",
  "validation.link.httpsOnly": "Links suportam apenas https://.",
  "validation.link.invalid": "Insira um link válido.",
  "validation.link.validEmail": "Insira um e-mail válido.",
  "validation.link.validGithub": "Insira um identificador GitHub válido.",
  "validation.link.validBilibili": "Insira um Bilibili UID válido.",
  "validation.link.validXiaohongshu": "Insira um link de perfil válido do Xiaohongshu.",
  "validation.link.validGoogleCalendar": "Insira um link de reserva Google Calendar válido.",
  "validation.link.validMicrosoftBookings": "Insira um link Microsoft Bookings válido.",
  "validation.theme.proRequired": "A publicação deste tema requer 30s Pro.",
  "validation.link.validHubSpot": "Insira um link HubSpot Meetings válido.",
  "validation.account.banned": "Esta conta não pode publicar no momento.",
  "validation.account.login": "Faça login primeiro.",
  "validation.account.invite": "Ative sua conta primeiro com um código de convite.",
  "validation.publish.failed": "A publicação falhou. Tente novamente mais tarde.",
  "validation.turnstile.required": "Conclua a verificação de segurança.",
  "validation.report.missing": "A página a ser denunciada não foi informada.",
  "validation.report.reason": "Escolha um motivo para a denúncia.",
  "validation.report.notReportable": "Esta página não pode ser denunciada no momento.",
  "common.listSeparator": ",",
  "dashboard.section.status": "Estado",
  "dashboard.section.performance": "Desempenho",
  "dashboard.fullAnalytics": "Ver análises completas",
  "dashboard.shareCard": "Compartilhar cartão",
  "dashboard.timestamp.notPublished": "Não publicado",
  "dashboard.timestamp.notEdited": "Não editado",
  "dashboard.timestamp.published": "Publicado em {date} UTC",
  "dashboard.timestamp.edited": "{date} UTC editado",
  "upgrade.publishTheme": "Publicar {theme}",
  "upgrade.copy": "Sua escolha foi salva e continua disponível para visualização completa. Após o upgrade, você poderá publicar sem editar novamente.",
  "upgrade.benefit.themes": "Publique todos os temas premium",
  "upgrade.benefit.analytics": "Veja tempo de leitura e conclusão",
  "upgrade.benefit.cards": "Cartões temáticos sincronizados com OG social",
  "upgrade.seePro": "Veja 30s Pro",
  "upgrade.keepEditing": "Continue editando",
  "pro.meta.title": "30s Pro – Expresse-se",
  "pro.meta.description": "Temas premium, análises de qualidade de leitura e cartões de compartilhamento que fazem com que sua introdução de 30 segundos pareça mais com você.",
  "pro.title": "Expresse quem você é.",
  "pro.intro": "A leitura continua em 30 segundos. Com o Pro, você ganha mais expressão, sinais mais claros e materiais prontos para compartilhar.",
  "pro.priceAction": "Ver Preço de Fundação",
  "pro.summaryAria": "Resumo dos benefícios do Pro",
  "pro.summaryThemes": "temas premium",
  "pro.summaryAnalytics": "dias de análise",
  "pro.summaryShare": "sincronizado com seu cartão",
  "pro.benefitsKicker": "Ferramentas Pro",
  "pro.benefitsTitle": "Da expressão ao alcance.",
  "pro.benefit.themes.title": "Temas premium",
  "pro.benefit.themes.body": "Oito temas liderados pelo Terminal. Visualize todos os temas gratuitamente; publique-os com o Pro.",
  "pro.benefit.analytics.title": "Qualidade de leitura",
  "pro.benefit.analytics.body": "Vá além das visitas: tempo de leitura ativa, taxa de conclusão, avanço na página, tendências de 30, 90 e 365 dias e CTR dos links.",
  "pro.benefit.share.title": "Compartilhe do seu jeito",
  "pro.benefit.share.body": "Grátis tem um cartão simples com nome e link. Pro adiciona dois cartões universais e um design para cada tema. Sua seleção se torna a imagem OG, com QR integrado para compartilhamento e download.",
  "pro.benefit.attribution.title": "Só você",
  "pro.benefit.attribution.body": "Oculte a assinatura do 30s.to dentro do tema sem remover recursos necessários, como denúncia e seleção de idioma.",
  "pro.pricingTitle": "Quanto antes você entrar, mais simples.",
  "pro.pricingBody": "Você mantém o Founding Price enquanto a assinatura continuar ativa. Se voltar depois do encerramento, valerá o preço vigente.",
  "pro.terminalAria": "Visualização do tema Terminal Pro",
  "pro.checkout.continuous": "Preço mantido enquanto a assinatura continuar",
  "pro.checkout.intervalAria": "Intervalo de cobrança",
  "pro.checkout.monthly": "Mensal",
  "pro.checkout.yearly": "Anual",
  "pro.checkout.save": "Economize US$ 16",
  "pro.checkout.periodYear": "ano",
  "pro.checkout.periodMonth": "mês",
  "pro.checkout.annualNote": "Equivale a ${price} por mês, 44% menos que o plano mensal.",
  "pro.checkout.monthlyNote": "Pague mês a mês e cancele quando quiser ao fim do período.",
  "pro.checkout.includeThemes": "Todos os temas premium",
  "pro.checkout.includeAnalytics": "Qualidade de leitura e análises de 365 dias",
  "pro.checkout.includeCards": "Cartões temáticos, QR e OG",
  "pro.checkout.includeAttribution": "Ocultar atribuição no tema",
  "pro.checkout.manage": "Gerenciar meu Pro",
  "pro.checkout.comingSoon": "Pagamento disponível em breve",
  "pro.checkout.signIn": "Entre para fazer upgrade",
  "pro.checkout.inviteRequired": "Você precisa de um convite Beta",
  "pro.checkout.opening": "Abrindo checkout seguro…",
  "pro.checkout.upgrade": "Atualize para 30s Pro",
  "pro.checkout.footnote": "Pagamento seguro com a Creem. Os impostos aparecem antes da cobrança; sem teste grátis e com renovação automática.",
  "pro.checkout.unavailable": "Não foi possível abrir o pagamento agora. Tente novamente mais tarde.",
  "pro.checkout.networkError": "Não foi possível conectar. Tente novamente mais tarde.",
  "billing.panelAria": "Pro e faturamento",
  "billing.plan": "Plano",
  "billing.status.canceling": "Cancelamento agendado",
  "billing.status.pastDue": "Pagamento pendente",
  "billing.status.active": "Ativo",
  "billing.status.free": "Grátis",
  "billing.yearly": "Anualmente",
  "billing.monthly": "Mensalmente",
  "billing.basicPlan": "Plano básico",
  "billing.ends": "Termina {date}",
  "billing.renews": "Renova {date}",
  "billing.graceEnds": "O período de carência termina: {date}",
  "billing.anomaly": "Seu status de faturamento precisa de revisão manual. Entre em contato com support@30s.to.",
  "billing.opening": "Abrindo a gestão de pagamentos",
  "billing.manage": "Faturamento",
  "billing.upgrade": "Atualizar para Pro",
  "billing.openingHistory": "Abrindo…",
  "billing.viewHistory": "Ver histórico de faturamento",
  "billing.portalUnavailable": "O gerenciamento de faturamento está temporariamente indisponível.",
  "billing.networkError": "A conexão de rede falhou. Por favor, tente novamente.",
  "billingReturn.kicker": "30s Pro · Confirmação segura",
  "billingReturn.activeTitle": "O Pro já está ativo",
  "billingReturn.failedTitle": "O pagamento ainda não foi confirmado",
  "billingReturn.waitingTitle": "Confirmando seu pagamento",
  "billingReturn.failedCopy": "Seu pagamento ainda pode estar sendo sincronizado. Verifique o Dashboard novamente mais tarde; o acesso nunca é concedido apenas pela página de retorno.",
  "billingReturn.waitingCopy": "Estamos verificando sua assinatura com o provedor de pagamento. Mantenha esta página aberta.",
  "billingReturn.back": "Voltar ao painel",
  "analytics.kicker": "30s Pro · Análises",
  "analytics.nav": "Análises",
  "analytics.title": "Da visita à leitura completa.",
  "analytics.copy": "Acompanhe o caminho da visita à leitura completa e aos cliques, sem rastrear pessoas. As datas e a remoção de duplicatas usam UTC.",
  "analytics.rangeAria": "Período",
  "analytics.days": "{count} dias",
  "analytics.uniqueVisitors": "Visitantes únicos",
  "analytics.rangeTotal": "Total de {count} dias",
  "analytics.averageReading": "Tempo médio de leitura ativa",
  "analytics.activeReadingNote": "Tempo em que a página ficou visível e ativa",
  "analytics.completionRate": "Taxa de conclusão",
  "analytics.completedVisitors": "{count} visitantes chegaram ao fim",
  "analytics.overallCtr": "CTR geral",
  "analytics.engagedVisitors": "{count} visitantes interagiram",
  "analytics.trafficTrend": "Tendência de tráfego",
  "analytics.dailyTrendAria": "Tendência diária de visitantes únicos",
  "analytics.readingCompletion": "Conclusão da leitura",
  "analytics.dailyMaximum": "Visitantes / máximo diário",
  "analytics.visitorCount": "{count} visitantes",
  "analytics.topLinks": "Links principais",
  "analytics.uniqueClickers": "Pessoas que clicaram",
  "analytics.linkTrendAria": "Tendência diária para {label}",
  "analytics.noInteractions": "Nenhuma interação de link ainda.",
  "analytics.audienceOverview": "Visão geral do público",
  "analytics.pageLevel": "Nível da página",
  "analytics.referrers": "Fontes de tráfego",
  "analytics.devices": "Dispositivos",
  "analytics.countries": "Países",
  "analytics.noData": "Ainda não há dados",
  "analytics.durationSeconds": "{seconds} s",
  "analytics.durationMinutes": "{minutes} min {seconds} s",
  "share.card": "Cartão de compartilhamento",
  "share.variant.classic": "Clássico",
  "share.variant.classicNote": "Silencioso",
  "share.variant.contact": "Índice",
  "share.variant.contactNote": "Estruturado",
  "share.variant.theme": "Edição {theme}",
  "share.variant.themeNote": "Tema",
  "share.variant.universal": "Universais",
  "share.saveFailed": "Não foi possível salvar",
  "share.styleUpdated": "Estilo atualizado",
  "share.networkError": "Falha na conexão de rede",
  "share.linkCopied": "Link copiado",
  "share.copyFailed": "Falha na cópia",
  "share.text": "Minha introdução de 30 segundos",
  "share.failed": "Não foi possível compartilhar",
  "share.published": "Publicado",
  "share.draft": "Rascunho",
  "share.style": "Estilo",
  "share.alt": "Cartão de compartilhamento de {name}",
  "share.publishFirst": "Publicar para compartilhar",
  "share.action": "Compartilhar",
  "share.download": "Baixar",
  "share.openPublicPage": "Abrir página pública",
  "share.chooseStyle": "Escolha o estilo do cartão",
  "share.close": "Fechar",
  "share.cardStyle": "Estilo de cartão",
  "share.chooseOne": "Escolha um estilo",
  "share.chooseStyleAria": "Escolha o estilo do cartão de compartilhamento",
  "share.saving": "Salvando",
  "validation.body.placeholderDetail.legacyTemplate": "o modelo de texto antigo",
  "validation.body.placeholderDetail.ellipsis": "o espaço reservado `...`",
  "validation.body.placeholderDetail.sampleLink": "o link de exemplo `https://example.com`",
  "validation.body.placeholderDetail.projectName": "o espaço reservado `项目名`",
  "validation.body.placeholderDetail.instruction": "texto de instrução do modelo",
  "analytics.gate.signInTitle": "Entre para ver as análises",
  "analytics.gate.signInCopy": "Seus dados de visitas e interações ficam protegidos no painel.",
  "analytics.gate.signInAction": "Entrar",
  "analytics.gate.proTitle": "Veja se sua apresentação é lida até o fim.",
  "analytics.gate.proCopy": "Confira tempo de leitura ativo, taxa de conclusão, distribuição de progresso, tendências de 30, 90 e 365 dias e CTR dos links.",
  "analytics.gate.proAction": "Conhecer o 30s Pro",
  "analytics.gate.emptyTitle": "Seus dados começam a aparecer após a publicação.",
  "analytics.gate.emptyCopy": "Conclua primeiro sua apresentação de 30 segundos. Depois de publicar, você poderá ver as tendências de visitas e interações.",
  "analytics.gate.emptyAction": "Começar a criar",
  "analytics.gate.privacyNote": "Agregação diária em UTC · Remoção anônima de duplicatas · O IP original não é armazenado",
  "handleEdit.previous": "Endereços anteriores protegidos",
  "handleEdit.deadlines": "Redirecionamento até {redirectDate}; proteção até {releaseDate}.",
  "handleEdit.usePrevious": "Usar este endereço",
  "handleEdit.reclaimAvailable": "Você pode recuperar este endereço anterior.",
  "publish.handleReclaimed": "Recuperar também conta como mudança de endereço. O endereço atual iniciará novos períodos de 30 dias de redirecionamento e 180 dias de proteção."
}
